export const L_TOKEN = '_l_exa'
export const CANDIDATE_ID = '_c_id'
export const ADMINS_ID = [2]
